<!--
// app/components/context-shared/ContextLogoLeagueFooter.vue
-->
<script setup lang="ts">
import { useWebContext } from "~/app/composables/webContext";
import { useRegions } from "~/app/composables/regions";
import { useWebappStore } from "~/app/stores/webappStore";
import RegionUiService from "~/src/region/infrastructure/ui-services/regionUiService";

const { locale } = useI18n();
const { isWorldCup, isNations, isKokNations, isMena, regionParam } = useRegions();
const webappStore = useWebappStore();
const { webContext } = useWebContext();
const { findRegionInfoBySlug } = RegionUiService();

const setFooterLogo = () => {
  if (isMena && locale.value === "ar") {
    return {
      src: "/img/league-logos/cups/kc-mena-rtl.png",
      alt: "Kings Cup MENA",
      width: 312,
      height: 108,
    };
  } else {
    if (regionParam) {
      return findRegionInfoBySlug(regionParam, "footerLogo");
    } else if (!regionParam && webappStore.activeRegion) {
      return findRegionInfoBySlug(webappStore.activeRegion, "footerLogo");
    } else {
      return undefined;
    }
  }
};

const competitionFooterLogo = setFooterLogo();
</script>

<template>
  <NuxtImg
    v-if="competitionFooterLogo"
    :src="competitionFooterLogo.src"
    :alt="competitionFooterLogo.alt"
    :class="isNations || isWorldCup || isKokNations ? 'logo-kwc' : 'logo'"
    loading="lazy"
    :width="competitionFooterLogo.width"
    :height="competitionFooterLogo.height"
    :sizes="isNations || isWorldCup ? '160px md:220px' : '180px md:250px'"
  />
</template>

<style scoped>
/*.logo {
  @apply w-[189px] md:w-[312px] h-auto;
}*/

.logo {
  @apply w-[180px] md:w-[250px] h-auto;
}

.logo-kwc {
  @apply w-[160px] md:w-[220px] h-auto;
}
</style>
